export enum EnumPermisos {
    PERMISO_CONFIGURACION_GENERAL = 'PERMISO_CONFIGURACION_GENERAL',
    PERMISO_PROYECTOS_CREAR = 'PERMISO_PROYECTOS_CREAR',
    PERMISO_PROYECTOS_EDITAR = 'PERMISO_PROYECTOS_EDITAR',
    PERMISO_PROYECTOS_ELIMINAR = 'PERMISO_PROYECTOS_ELIMINAR',
    PERMISO_PROYECTOS_VER = 'PERMISO_PROYECTOS_VER',
    PERMISO_REPORTES_GENERALES_VER = 'PERMISO_REPORTES_GENERALES_VER',
    PERMISO_USUARIOS_CREAR = 'PERMISO_USUARIOS_CREAR',
    PERMISO_USUARIOS_EDITAR = 'PERMISO_USUARIOS_EDITAR',
    PERMISO_USUARIOS_ELIMINAR = 'PERMISO_USUARIOS_ELIMINAR',
    PERMISO_USUARIOS_VER = 'PERMISO_USUARIOS_VER',
    PERMISO_TAREAS_CREAR = 'PERMISO_TAREAS_CREAR',
    PERMISO_TAREAS_EDITAR = 'PERMISO_TAREAS_EDITAR',
    PERMISO_TAREAS_CANCELAR = 'PERMISO_TAREAS_CANCELAR',
    PERMISO_TAREAS_VER = 'PERMISO_TAREAS_VER',
    PERMISO_TAREAS_ASIGNAR_TECNICO = 'PERMISO_TAREAS_ASIGNAR_TECNICO',
    PERMISO_TAREAS_ASIGNAR_TECNICO_NBS = 'PERMISO_TAREAS_ASIGNAR_TECNICO_NBS',
    PERMISO_TAREAS_ASIGNAR_VERIFICADOR_CALIDAD = 'PERMISO_TAREAS_ASIGNAR_VERIFICADOR_CALIDAD',
    PERMISO_TAREAS_VER_SOLO_INSTALACION = 'PERMISO_TAREAS_VER_SOLO_INSTALACION',
    PERMISO_MATERIALES_CREAR = 'PERMISO_MATERIALES_CREAR',
    PERMISO_MATERIALES_EDITAR = 'PERMISO_MATERIALES_EDITAR',
    PERMISO_MATERIALES_ELIMINAR = 'PERMISO_MATERIALES_ELIMINAR',
    PERMISO_MATERIALES_VER = 'PERMISO_MATERIALES_VER',
    PERMISO_VER_AGENDA = 'PERMISO_VER_AGENDA',
    PERMISO_VER_COTIZADOR = 'PERMISO_VER_COTIZADOR',
    PERMISO_GESTION_ARCHIVOS_VER = 'PERMISO_VER_PORTAL_CLIENTE',
    PERMISO_GESTION_ARCHIVOS_NBS_VER = 'PERMISO_GESTION_ARCHIVOS_NBS_VER',
    PERMISO_REPORTES_CLIENTE_VER = 'PERMISO_REPORTES_CLIENTE_VER',
    // Permisos por reporte individual
    PERMISO_REPORTE_HORAS_HOMBRE_VER = 'PERMISO_REPORTE_HORAS_HOMBRE_VER',
    PERMISO_ASISTENTE_IA_VER = 'PERMISO_ASISTENTE_IA_VER',
    PERMISO_MONITOR_VER = 'PERMISO_MONITOR_VER',
    // Permisos NBS
    PERMISO_VISITA_INSTALACION_VER = 'PERMISO_VISITA_INSTALACION_VER',
    PERMISO_VISITA_INSTALACION_CREAR = 'PERMISO_VISITA_INSTALACION_CREAR',
    PERMISO_VISITA_INSTALACION_TODAS_ACTIVIDADES = 'PERMISO_VISITA_INSTALACION_TODAS_ACTIVIDADES',
    PERMISO_VISITA_INSTALACION_EDITAR = 'PERMISO_VISITA_INSTALACION_EDITAR',
    PERMISO_VISITA_INSTALACION_ASIGNAR_TECNICO_SERVICIO = 'PERMISO_VISITA_INSTALACION_ASIGNAR_TECNICO_SERVICIO',
    PERMISO_CALIDAD_VERIFICAR = 'PERMISO_CALIDAD_VERIFICAR',
    // Cotizador NBS (documento de requerimientos del cliente, 2026-10-15). Solo NBS: los demás cotizadores no cambian.
    PERMISO_COTIZADOR_NBS_VER = 'PERMISO_COTIZADOR_NBS_VER',
    PERMISO_COTIZADOR_NBS_CONFIGURAR = 'PERMISO_COTIZADOR_NBS_CONFIGURAR',
    PERMISO_COTIZADOR_NBS_VER_TODAS = 'PERMISO_COTIZADOR_NBS_VER_TODAS',
    PERMISO_COTIZADOR_NBS_DESCUENTOS_MARGEN = 'PERMISO_COTIZADOR_NBS_DESCUENTOS_MARGEN',
    // Más de 12 meses de mantenimiento a costo (autorización de la gerencia comercial)
    PERMISO_COTIZADOR_NBS_MANTENIMIENTO_EXTENDIDO = 'PERMISO_COTIZADOR_NBS_MANTENIMIENTO_EXTENDIDO',
    // Editar el porcentaje de pólizas en la configuración de una cotización de Panamá (perfil comercial)
    PERMISO_COTIZADOR_NBS_EDITAR_POLIZAS = 'PERMISO_COTIZADOR_NBS_EDITAR_POLIZAS',
    // Cotizadores de Servicios y Postventa (aún en desarrollo: solo los ve quien tenga el permiso)
    PERMISO_COTIZADOR_SERVICIOS_VER = 'PERMISO_COTIZADOR_SERVICIOS_VER',
    PERMISO_COTIZADOR_SERVICIOS_CONFIGURAR = 'PERMISO_COTIZADOR_SERVICIOS_CONFIGURAR',
    PERMISO_COTIZADOR_POSTVENTA_VER = 'PERMISO_COTIZADOR_POSTVENTA_VER',
    PERMISO_COTIZADOR_POSTVENTA_CONFIGURAR = 'PERMISO_COTIZADOR_POSTVENTA_CONFIGURAR',
}